module.exports = __webpack_public_path__ + "img/Capacity.6006d917.svg";